import styled from '@emotion/styled';
import { MixinFocusVisible } from '../structure/DefaultStyles';
import { LightSmall } from '../text/Typography';

export const HeadingDescription = styled(LightSmall)`
    max-width: 800px;
`;

export const HeaderTextWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-self: self-end;
    padding: 0 0 0.25rem 0;
    flex: 1;
    min-width: 60%; // ensure the header text doesn't get too small and takes up appropriate portion of header
`;

export const HeaderChildWrap = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const HeaderContainer = styled.header`
    flex-basis: 100%;
    height: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
    border-bottom: ${({ theme }) => `1px solid ${theme.color.sidebarDivider}`};
`;

export const HomeLink = styled.a`
    color: ${({ theme }) => theme.color.text};
    display: flex;
    height: 42px;
    ${MixinFocusVisible}
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
`;
